import script from "./like.vue?vue&type=script&setup=true&lang=js"
export * from "./like.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__